import React, { useState, useEffect } from "react";
import "../../styles/desktop/ar.css";

import { comandoAr } from '../../API/basic/AcionamentoAr';
import { statusAr } from '../../API/basic/FeedbackAr';

import arParedeLigado from "../../assets/img/Area Ar Condicionado/arCondicionado.png";
import arParedeDesligado from "../../assets/img/Area Ar Condicionado/arCondicionadoDesligado.png";
import arTetoLigado from "../../assets/img/Area Ar Condicionado/arCondicionadoTeto.png";
import arTetoDesligado from "../../assets/img/Area Ar Condicionado/arCondicionadoTetoDesligado.png";
import espacoImageAcad from "../../assets/img/Area Ar Condicionado/academia.png";
import espacoImageRooftopWineBar from "../../assets/img/Area Ar Condicionado/rooftopWineBar.png";
import espacoImageRooftopBeerHouse from "../../assets/img/Area Ar Condicionado/rooftopBeerHouse.png";
import espacoImageRooftopHall from "../../assets/img/Area Ar Condicionado/rooftopHall.png";
import espacoImageSalaoDeFestas from "../../assets/img/Area Ar Condicionado/salaoDefestas.png";
import espacoImageBrinquedoteca from "../../assets/img/Area Ar Condicionado/brinquedoteca.png";
import espacoImagemSalaDeJogos from "../../assets/img/Area Ar Condicionado/SalaDeJogos.png";
import espaconImageGardenGourmet from "../../assets/img/Area Ar Condicionado/gardenGourmet.png";
import espacoImagemSalaDeReuniao from "../../assets/img/Area Ar Condicionado/SalaDeReuniao.png";
import voltar from "../../assets/mobile/icones/volte.png";

const ArCondicionado = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [espacoArCondicionados, setEspacoArCondicionados] = useState([
    { nome: "Rooftop Wine Bar", espacoImg: espacoImageRooftopWineBar, ares: [{ id: 1, tipo: "teto", status: false, x: 15, y: 15 }, { id: 2, tipo: "teto", status: false, x: 43, y: 53 }] },
    { nome: "Rooftop Beer House", espacoImg: espacoImageRooftopBeerHouse, ares: [{ id: 1, tipo: "teto", status: false, x: 47, y: 36 }, { id: 2, tipo: "teto", status: false, x: 14, y: 4 }] },
    { nome: "Rooftop Hall", espacoImg: espacoImageRooftopHall, ares: [{ id: 1, tipo: "parede", status: false, x: 50, y: 11, rotate: "90deg" }, { id: 2, tipo: "parede", status: false, x: 11, y: 10, rotate: "-90deg" }] },
    { nome: "Salão de Festas", espacoImg: espacoImageSalaoDeFestas, ares: [{ id: 1, tipo: "teto", status: false, x: 12, y: 15 }, { id: 2, tipo: "teto", status: false, x: 14, y: 55 }, { id: 3, tipo: "teto", status: false, x: 33, y: 13 }, { id: 4, tipo: "teto", status: false, x: 32, y: 52 }, { id: 5, tipo: "teto", status: false, x: 53, y: 32 }] },
    { nome: "Academia", espacoImg: espacoImageAcad, ares: [{ id: 1, tipo: "parede", status: false, x: 28, y: -4 }, { id: 2, tipo: "parede", status: false, x: 56, y: -4 }, { id: 3, tipo: "parede", status: false, x: 8, y: 73, rotate: "180deg" }, { id: 4, tipo: "parede", status: false, x: 30.5, y: 73, rotate: "180deg" }, { id: 5, tipo: "parede", status: false, x: 53, y: 73, rotate: "180deg" }] },
    { nome: "Brinquedoteca", espacoImg: espacoImageBrinquedoteca, ares: [{ id: 1, tipo: "parede", status: false, x: 59, y: 62.5, rotate: "90deg" }] },
    { nome: "Gourmet Privativo", espacoImg: espaconImageGardenGourmet, ares: [{ id: 1, tipo: "teto", status: false, x: 16, y: 15 }, { id: 2, tipo: "teto", status: false, x: 35, y: 55 }] },
    { nome: "Sala de Jogos", espacoImg: espacoImagemSalaDeJogos, ares: [{ id: 1, tipo: "parede", status: false, x: 60.5, y: 33, rotate: "90deg" }] },
    { nome: "Sala de Reunião", espacoImg: espacoImagemSalaDeReuniao, ares: [{ id: 1, tipo: "teto", status: false, x: 30, y: 35 }] },
  ]);

  const handleExpand = (index) => {
    setExpandedIndex(index);
  };

  const handleCollapse = (event) => {
    event.stopPropagation();
    setExpandedIndex(null);
  };

  const toggleStatus = (espacoIndex) => {
    setEspacoArCondicionados((prevEspacos) => {
      const updatedEspacos = [...prevEspacos];
      const espacoAtual = updatedEspacos[espacoIndex];

      const algumLigado = espacoAtual.ares.some((arAtual) => arAtual.status);
      const acao = algumLigado ? "desligar" : "ligar";
      const nomeGrupo = espacoAtual.nome;

      espacoAtual.ares.forEach((arAtual) => {
        arAtual.status = !algumLigado;
        arAtual.isTemporary = true; // Marca como temporário
      });

      console.log(`Enviando comando para ${nomeGrupo} ${acao} todos os ares-condicionados`);
      comandoAr(nomeGrupo, acao)
        .then((response) => {
          console.log(`Ação ${acao} executada com sucesso para ${nomeGrupo}`);
        })
        .catch((error) => {
          console.error(`Erro ao executar a ação ${acao} para ${nomeGrupo}:`, error);
        });

      setTimeout(() => {
        espacoAtual.ares.forEach((arAtual) => {
          arAtual.isTemporary = false;
        });
        fetchStatusAr(nomeGrupo);
      }, 60000); // Restaura após 1 minuto

      return updatedEspacos;
    });
  };

  const fetchStatusAr = async (espacoNome) => {
    try {
      const feedback = await statusAr();
      console.log("Feedback de ar-condicionado:", feedback);

      if (!feedback || feedback.length === 0) {
        console.error("Nenhum feedback recebido da API");
        return;
      }

      setEspacoArCondicionados((prevEspacos) => {
        const updatedEspacos = [...prevEspacos];

        updatedEspacos.forEach((espacoAtual) => {
          if (espacoAtual.nome === espacoNome) {
            espacoAtual.ares.forEach((arAtual) => {
              if (!arAtual.isTemporary) {
                const normalizeString = (str) => str.toLowerCase().trim();
                const feedbackItem = feedback.find(
                  (item) => 
                    normalizeString(item.nome) === normalizeString(espacoAtual.nome) &&
                    item.id === arAtual.id
                );

                if (feedbackItem) {
                  arAtual.status = feedbackItem.status === "ON";
                } else {
                  console.warn(`Nenhum status encontrado para ${espacoAtual.nome} - ${arAtual.id}`);
                }
              }
            });
          }
        });

        return updatedEspacos;
      });
    } catch (error) {
      console.error("Erro ao obter o feedback de ar-condicionado:", error);
    }
  };

  useEffect(() => {
    if (expandedIndex !== null) {
      const espacoAtual = espacoArCondicionados[expandedIndex];
      fetchStatusAr(espacoAtual.nome);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedIndex]);

  const getArImage = (tipo, status) => {
    if (tipo === "parede") {
      return status ? arParedeLigado : arParedeDesligado;
    } else if (tipo === "teto") {
      return status ? arTetoLigado : arTetoDesligado;
    }
    return null;
  };

  const todosEstaoLigados = (ares) => ares.every((ar) => ar.status);

  return (
    <div className="contentAr">
      <div className="espacoArCondicionado">
        {espacoArCondicionados.map((espaco, index) => (
          <div
            key={index}
            className={`arCondicionado ${expandedIndex === index ? "expanded" : ""}`}
            onClick={() => handleExpand(index)}
          >
            <h1 className={`tituloArCondicionado ${expandedIndex === index ? "expanded" : ""}`}>
              {espaco.nome}
            </h1>
            {expandedIndex === index && (
              <div className="AresCondicionados">
                <div className="botaoVoltarArCondicionado" onClick={handleCollapse}>
                  <img id="imgVoltar" src={voltar} alt="Retornar" />
                </div>
                <div className="espacoImage">
                  <img className="imagemEspacoArCondicionado" src={espaco.espacoImg} alt="Espaço" />
                </div>
                <div className="menuArCondicionado">
                  <div className="botaoLigarDesligarArCondicionado">
                    <p className="statusGrupoArCondicionados">
                      {todosEstaoLigados(espaco.ares) ? "Desligar" : "Ligar"}
                    </p>
                    <label className="switch">
                      <input 
                        type="checkbox" 
                        checked={todosEstaoLigados(espaco.ares)}
                        onChange={() => toggleStatus(index)} 
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                  {espaco.ares.map((ar, arIndex) => (
                    <React.Fragment key={arIndex}>
                      <div className="arCondicionadoImagem">
                        <img
                          className="imagemArCondicionado"
                          src={getArImage(ar.tipo, ar.status)}
                          alt="Ar Condicionado"
                          style={{ left: `${ar.x}%`, top: `${ar.y}%`, rotate: `${ar.rotate}` }}
                        />
                      </div>
                      <div className="textArCondicionado">
                        <p className="tituloArCondicionado">Ar {ar.tipo} {ar.id}</p>
                        <div className="campobotaoArCondicionado">
                          <p className="statusArCondicionado">Status: {ar.status ? "Ligado" : "Desligado"}</p>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArCondicionado;
